import React, {useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import Popup from "reactjs-popup";

import Aux from "../../../hoc/Auxiliary";

import TableContainer from "./Table/TableContainer";
import Spinner from "../../UI/Spinner";
import axios from "../../../axios-defaults";
import {Link} from "react-router-dom";
import AccordionTab from "../../UI/Accordion/AccordionTab";

const Assignments = (props) => {
    const {t, i18n} = useTranslation();
    let itemsRaw = [];
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filteredItems, setFilteredItems] = useState([]);

    const getAssignments = async() => {
       await axios.get(`/assignments`)
            .then(response => {
                if (response.data.succeeded)  {
                    mapAssignment(response.data.data);
                }
            }).catch(error => {
                console.log('[Profile.js] : Communications ajax error in getAssignments()', error.message)
            });
    }

    const mapAssignment = (assignments) => {
        if (assignments.length) {
            let itemsArr = [];

            assignments.forEach((item) => {
                let newItem = {
                    id: item.id,
                    user_id: item.user_id,
                    user: item.toUser,
                    role: item.role,
                    created_at: item.created_date,
                    redeemed: item.redeemed,
                    account_codes: item.account_codes,
					permission: item.permission_type,
					data_access: item.data_access,
                };
                itemsArr.push(newItem)
            });
            setItems(itemsArr);
            setFilteredItems(itemsArr);
        }
    }

    useEffect(() => {
        setLoading(true)
        getAssignments();
        setLoading(false)
    }, []);

    const btnDeleteModal = (assignmentId) => (
        <Popup closeOnDocumentClick={false} trigger={<Link to={"#"} className="link link--fs-14 link--accent link--red link--upper">
            <strong>{t('profile.assignments.list.row.delete')}&nbsp;&nbsp;<i className="fas fa-times"></i></strong>
        </Link>} modal>
            {close => (
                <div className="popup-delete">
                    <div className="content">{t("profile.assignments.confirm_delete")}</div>
                    <div className="actions">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                                close();
                            }}
                        >{t('profile.assignments.list.row.cancel')}</button>
                        <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                axios.delete(`/assignments/${assignmentId}`)
                                    .then(response => {
                                        if (response.data.succeeded) {
                                            let newItems = items.filter(item => item.id !== assignmentId)
                                            setFilteredItems(newItems);
                                            setItems(newItems);
                                            close();
                                        }
                                    })
                                    .catch(error => {
                                        console.log('[AccountsList.js] : Favorites ajax error in addRemoveFavoriteHandler()', error.message);
                                        close();
                                    })
                            }}
                        >{t('profile.assignments.list.row.delete')}</button>

                    </div>
                </div>
            )}
        </Popup>
    );

    const btnSetAsOwnerModal = (assignmentId) => (
        <Popup closeOnDocumentClick={false}  trigger={<Link to={"#"} className="link link--fs-14 link--accent link--red link--upper">
            <strong>{t('profile.assignments.list.row.set_as_owner')}&nbsp;&nbsp;<i className="fas fa-plus"></i></strong>
        </Link>} modal>
            {close => (
                <div className="popup-delete">
                    <div className="content">{t("profile.assignments.confirm_set_as_owner")}</div>
                    <div className="actions">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                                close();
                            }}
                        >{t('profile.assignments.list.row.cancel')}</button>
                        <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                axios.put(`/assignments/${assignmentId}/set-as-owner`)
                                    .then(response => {
                                        if (response.data.succeeded) {
                                            let newItems = items.filter(item => item.id !== assignmentId)
                                            setFilteredItems(newItems);
                                            setItems(newItems);
                                            close();
                                            window.location.reload(false);
                                        }
                                    })
                                    .catch(error => {
                                        console.log('[AccountsList.js] : Favorites ajax error in addRemoveFavoriteHandler()', error.message);
                                        close();
                                    })
                            }}
                        >{t('profile.assignments.list.row.set_as_owner')}</button>

                    </div>
                </div>
            )}
        </Popup>
    );

    const columns = useMemo(
        () => [
            {
                Header: t('profile.assignments.list.header.user'),
                accessor: "user",
                Cell: (props) => {
                    if (props.value) {
                        return (
                            <Aux>
                                <p>
                                {props.value.name != "" ? <Aux>{props.value.name}{<br/>}</Aux> : ''}
                                {props.value.email}</p>
                            </Aux>
                        );
                    } else {
                        return '';
                    }
                },
            },
            // { //currently is only administrator role
            //     Header: t('profile.assignments.list.header.role'),
            //     accessor: "role",
            //     Cell: (props) => {
            //         let text = 'profile.assignments.list.role.' + props.value
            //         return (
            //             <Aux>
            //                 <p>{t(text)}</p>
            //             </Aux>
            //         );
            //     },
            // },
            {
                Header: t('profile.assignments.list.header.permission'),
                accessor: "data_access",
                Cell: (props) => {
                    if (props.value) {
                        let text = 'profile.assignments.permission.' + props.value.type
                        return (
                            <Aux>
                                <p>{t(text)}</p>
								<ul>
									{
										props.value.list.map((name) => {
											return <li key={name}>{t("profile.assignments.form.specific_permissions.key."+name)}</li>
										})
									}
								</ul>
                            </Aux>
                        );
                    } else {
                        return '';
                    }
                },
            },
            // { The code is ready for a future need
            //     Header: t('profile.assignments.list.header.redeemed'),
            //     accessor: "redeemed",
            //     Cell: (props) => {
            //         return (
            //             <Aux>
            //                 <p>{t(props.value && props.value == 1 ? 'profile.assignments.list.redeemed.yes' : 'profile.assignments.list.redeemed.no')}</p>
            //             </Aux>
            //         );
            //     },
            // },
            {
                Header: '',
                accessor: "id",
                Cell: (props) => {
                    if (props.value) {
                        return (
                            <Aux>
                                <p>
                                    <Link to={"#"} className="link link--fs-14 link--accent link--red link--upper"
                                          to={`/profile/assignments/edit/${props.value}`}>
                                        <strong>{t('profile.assignments.list.row.edit')}&nbsp;&nbsp;<i
                                            className="fas fa-angle-right"></i></strong>
                                    </Link>
                                </p>
                                <p>
                                    {btnDeleteModal(props.value)}
                                </p>
                                {(typeof props.cell.row.original.user_id !== 'undefined' && props.cell.row.original.user_id !== null) ? (
                                    <p>
                                        {btnSetAsOwnerModal(props.value)}
                                    </p>
                                ) : null}
                            </Aux>
                        );
                    } else {
                        return '';
                    }
                },
            }
        ],
        [items, t, i18n]
    );

    let dataHtml = '';
    if (props.loading || loading) {
        dataHtml = <Spinner/>;
    } else {
        dataHtml = (
            <Aux>
                <TableContainer
                    columns={columns}
                    data={filteredItems}
                />
            </Aux>
        );
    }

    return (
        <Aux>
            <div className="assignment-profile-head">
                <h2 className="headline headline--section headline--uppercase">
                    {t("profile.employes")}
                </h2>
                <div className="buttons">
                    <Link to={"#"} className='btn btn-secondary btn-sm mb-3' to='/profile/assignments/add'>
                        {t("profile.assignments.addbtn")}
                        <i className="far fa-user-plus"></i>
                    </Link>
                </div>
            </div>
            {dataHtml}
        </Aux>
    );
};

export default Assignments;
